<template>
  <div>
    <TopBar />

    <v-card :loading="loading">
      <v-toolbar
        dark
      >
        <v-toolbar-title>Start new worksession</v-toolbar-title>

        <div class="flex-grow-1"></div>

        <v-btn color="white" icon @click="doStartWorkSession" :loading="loading">
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container>
        <v-row align="center">
          <v-col class="d-flex" cols="12">
            <v-select
              :items="getWorkSites"
              item-text="name"
              item-value="workSiteId"
              label="Choose work site"
              v-model="ws.workSiteId"
              :error-messages="errorMessage"
              @change="errorMessage=''"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <HoursInput label="Manager worked hours" v-model="ws.spentHours" value="ws.spentHours" />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <router-link :to="{name: 'home'}"><v-btn text>Back</v-btn></router-link>
        <v-btn color="primary" @click="doStartWorkSession" :loading="loading">Add</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TopBar from '../components/TopBar'
import HoursInput from "../components/HoursInput"

export default {
  components: {
    TopBar,
    HoursInput
  },
  data () {
    return {
      ws: {
        workSiteId: '',
        spentHours: 0
      },
      errorMessage: '',
      loading: false
    }
  },
  methods: {
    ...mapActions(['startWorksession', 'fetchWorkSites']),
    doStartWorkSession () {
      if (this.ws.workSiteId) {
        this.loading = true
        this.startWorksession(this.ws).then(() => {
          this.$router.push('/')
        })
      } else {
        this.errorMessage = 'Select a worksite!'
        this.loading = false
      }
    }
  },
  computed: {
    ...mapGetters(['getUser', 'getWorkSites'])
  },
  created () {
    this.fetchWorkSites()
    if (this.getUser.workSession !== null) {
      this.$router.push('/')
    }
  }
}
</script>
